<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div>
    <br />
    <div class='titleContainer'>
      <h2 class='header'>Settings</h2>
    </div>
    <br />

    <div class="row">
      <div class="col">
        @for (navItem of this.items; track navItem) {
          <button
            type="button"
            class="btn btn-secondary mr-2 mb-2"
            [disabled]="!navItem.enabled"
            routerLink="/4workshop{{navItem.link}}"
          ><i class="{{navItem.icon}}"></i> {{navItem.name}}</button>
        }
      </div>
    </div>
  </div>
</div>
